// @ts-check
// El "10 % del XP" que cuesta pedir una pista, en un solo sitio.
//
// ## Por qué existe este archivo
//
// El mismo número estaba escrito a mano en 10 cadenas repartidas por cuatro
// archivos: los tres paneles de intento (diagramas, pseudocódigo, Python) y
// `components/graded-feedback.js`. Si el porcentaje cambiara, habría que
// acordarse de los diez; olvidarse de uno significa PROMETERLE al alumno un
// descuento distinto del que se le va a aplicar de verdad.
//
// ## Dónde está la fuente de verdad de verdad
//
// En el BACKEND, no aquí: `backend/src/app/services/autocorrection_service.py`
// y `text_correction_service.py` calculan `round(puntuacion_xp * 0.10)`. Esta
// constante es la copia de cliente, y existe SOLO para redactar los textos que
// ve el alumno. El frontend nunca calcula la penalización real (§10.1 de
// docs/03-frontend.md: el frontend no es la única validación ni la
// autoridad). Si el backend cambia el 0.10, hay que cambiar `FRACCION_...`
// aquí -- y entonces las diez cadenas se actualizan solas.
//
// ## Los textos no cambian ni un carácter
//
// Se componen a partir de la constante de forma que el resultado sea
// EXACTAMENTE el mismo que estaba escrito a mano (hay pruebas que los afirman
// literalmente). Ojo con el espacio antes del `%`: los paneles escriben
// "10%" y `graded-feedback.js` escribe "10 %". Se conservan los dos tal cual;
// unificarlos sería un cambio de texto visible, no una refactorización.
//
// El panel de diagramas (`features/diagram-editor/autocorrection-panel.js`)
// tiene las mismas tres frases y está en la ZONA PROTEGIDA: no se toca. Sus
// cadenas siguen escritas a mano allí, idénticas a las que compone este
// módulo.

/** Fracción del XP máximo que descuenta pedir la pista. Espejo de cliente del
 * `0.10` del backend (ver cabecera). */
export const FRACCION_PENALIZACION_PISTA = 0.1;

/** El mismo valor en porcentaje entero, que es como se le cuenta al alumno. */
export const PORCENTAJE_PENALIZACION_PISTA = Math.round(FRACCION_PENALIZACION_PISTA * 100);

/** Aviso de la ventana emergente que pide confirmación antes de gastar la pista. */
export const AVISO_CONFIRMAR_PISTA = `Pedir la pista resta un ${PORCENTAJE_PENALIZACION_PISTA}% del XP máximo de este ejercicio, una sola vez por intento. ¿Quieres continuar?`;

/** Texto del botón que confirma la pista: repite el coste para que no se
 * confirme sin verlo. */
export const ETIQUETA_CONFIRMAR_PISTA = `Confirmar pista (resta ${PORCENTAJE_PENALIZACION_PISTA}% del XP máximo)`;

/** Lo que se anuncia (live region) una vez la pista ya se ha mostrado y el
 * descuento ya está hecho. */
export const MENSAJE_PISTA_MOSTRADA = `Pista mostrada. Recuerda que se ha descontado un ${PORCENTAJE_PENALIZACION_PISTA}% del XP máximo de este intento.`;

/** Explicación por defecto del coste en la ayuda graduada
 * (`components/graded-feedback.js`). Aquí el porcentaje va con espacio antes
 * del `%`, como estaba escrito. */
export const COSTE_PISTA_AYUDA_GRADUADA = `Pídela con el botón «Pedir pista» durante un intento abierto: te descontará un ${PORCENTAJE_PENALIZACION_PISTA} % de la puntuación de ese intento.`;
